import { X } from 'lucide-react';
import type { ToastItem } from '../context/ToastContext';
import { cn } from '../lib/utils';

export function ToastViewport({
  toasts,
  onDismiss,
}: {
  toasts: ToastItem[];
  onDismiss: (id: string) => void;
}) {
  if (toasts.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed right-4 top-4 z-[100] flex w-full max-w-sm flex-col gap-2"
      aria-live="polite"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={cn(
            'pointer-events-auto flex items-start gap-2 rounded-card border px-4 py-3 text-sm shadow-card',
            toast.variant === 'success' && 'border-ops-success/30 bg-ops-success-soft text-ops-text',
            toast.variant === 'error' && 'border-ops-danger/30 bg-ops-danger-soft text-ops-danger',
            toast.variant === 'info' && 'border-ops-border bg-ops-surface text-ops-text',
          )}
        >
          <p className="flex-1">{toast.message}</p>
          <button
            type="button"
            className="shrink-0 text-ops-muted hover:text-ops-text"
            onClick={() => onDismiss(toast.id)}
            aria-label="Закрыть"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
